var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-6 text-center max-w-lg mx-auto px-8",attrs:{"id":"app"}},[_c('HelloWorld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }